import { render, staticRenderFns } from "./DocumentosVazio.vue?vue&type=template&id=06b5819a&scoped=true&"
import script from "./DocumentosVazio.vue?vue&type=script&lang=js&"
export * from "./DocumentosVazio.vue?vue&type=script&lang=js&"
import style0 from "./DocumentosVazio.vue?vue&type=style&index=0&id=06b5819a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b5819a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VRow})
